module.exports = "#content {\n  font-size: 10px; }\n\ntable {\n  min-width: 100%; }\n\ntable th {\n    color: white;\n    text-transform: capitalize; }\n\ntable tr {\n    border-bottom: 1px solid #ccc; }\n\ntable tr:nth-child(even) {\n      background: #CCC; }\n\ntable tr:nth-child(odd) {\n      background: #FFF; }\n\ntable th, table td {\n    padding: 5px 2px;\n    max-width: 150px;\n    width: 150px;\n    min-width: 150px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/cierant-dynamic-report/cierant-dynamic-report.component.scss
// module id = ./src/app/shared/components/cierant-dynamic-report/cierant-dynamic-report.component.scss
// module chunks = main